const langUserNavigation = {
	dashboard: {
		tag: 'user.navigation.dashboard',
		fr: 'Tableau de bord',
		en: 'Dashboard',
	},
	investments: {
		tag: 'user.navigation.investments',
		fr: 'Mes investissements',
		en: 'My investments',
	},
	documents: {
		tag: 'user.navigation.documents',
		fr: 'Mes documents',
		en: 'My documents',
	},
	products: {
		tag: 'user.navigation.products',
		fr: 'Produits',
		en: 'Products',
	},
	news: {
		tag: 'user.navigation.news',
		fr: 'Actualités Sienna',
		en: 'Sienna news',
	},
	faq: {
		tag: 'user.navigation.faq',
		fr: 'FAQ',
		en: 'FAQ',
	},
};

export default langUserNavigation;
